import { Action } from '@ngrx/store';

export const CANCEL_JOB_SUBMISSION_SUCCESS = '[Submission] Cancel Job Submission Success';

export class CancelJobSubmissionSuccessAction implements Action {
  readonly type = CANCEL_JOB_SUBMISSION_SUCCESS;
}



// WEBPACK FOOTER //
// ./src/app/submission/store/actions/CancelJobSubmissionSuccessAction.ts